(function () {
  'use strict'

  require('./scss/videogular/videogular.scss')

  const MODULE_NAME = 'thismoment.common.component.video.core'
  const templateUrl = require('./tpl/video.html')

  angular
    .module(MODULE_NAME, [
      require('videogular'),
      require('videogular-buffering'),
      require('videogular-controls'),
      require('videogular-overlay-play'),
      require('videogular-poster'),
      require('../../directive/background-image'),
      require('./directive/tm-volume-bar')
    ])
    .run(runConfig)
    .component('thismomentVideo', {
      bindings: {
        autoplay: '<?',
        callbackVideoError: '&',
        isModal: '<?',
        isPreview: '<',
        item: '=',
        placeholder: '<',
        trackEvent: '&'
      },
      templateUrl: templateUrl,
      controller: videoController
    })

  runConfig.$inject = ['$templateCache']
  function runConfig ($templateCache) {
    $templateCache.put('vg-templates/vg-poster',
      '<div ng-class="vm.API.currentState" background-image="{{vgUrl}}"></div>'
    )
    $templateCache.put('vg-templates/vg-media-video',
      '<div class="embed-responsive embed-responsive-16by9">' +
                '<video class="embed-responsive-item"></video>' +
            '</div>'
    )
  }

  videoController.$inject = ['$injector', '$rootScope', '$scope', 'VG_STATES']
  function videoController ($injector, $rootScope, $scope, VG_STATES) {
    var vm = this
    var info = null
    var totalMiliseconds = null
    var progressTracks = []

    vm.vgConfig = {
      preload: (vm.isPreview) ? 'preload' : 'auto',
      theme: {
        url: ''
      },
      plugins: {
        controls: {
          autoHide: true,
          autoHideTime: 5000
        }
      }
    }

    vm.analytics = {
      category: {
        type: 'video',
        ccmtContentId: {}
      },
      label: 'Video Player',
      events: {
        ready: false,
        play: true,
        pause: false,
        stop: false,
        complete: false
      }
    }

    vm.$onInit = function () {
      vm.onPlayerReady = onPlayerReady
      vm.onError = onError
      vm.analytics.category.ccmtContentId = vm.item.id

      if ($injector.has('GlowConfig')) {
        var GlowConfig = $injector.get('GlowConfig')
        vm.showControls = !GlowConfig.get('playlistKioskMode')
      } else {
        vm.showControls = true
      }
    }

    function onPlayerReady (API) {
      vm.API = API
      if (vm.isModal) {
        vm.API.mediaElement.toggleClass('embed-responsive-item')
        vm.API.mediaElement.parent().toggleClass('embed-responsive')
        vm.API.mediaElement.parent().toggleClass('embed-responsive-16by9')
        vm.API.mediaElement.parent().css('width', '100%')
        vm.API.mediaElement.parent().css('height', '100%')
      }
    }

    function onError () {
      if (angular.isFunction(vm.callbackVideoError)) {
        vm.callbackVideoError()
      }
    }

    vm.onChangeState = function onChangeState (state) {
      switch (state) {
        case VG_STATES.PLAY:
          vm.trackEvent({
            action: 'Content Converted',
            properties: {
              'event trigger': 'Video Started'
            }
          })
          break

        case VG_STATES.PAUSE:
          vm.trackEvent({
            action: 'Content Converted',
            properties: {
              'event trigger': 'Video Paused'
            }
          })
          break

        case VG_STATES.STOP:
          $rootScope.$emit('videoCompleted')
          vm.trackEvent({
            action: 'Content Converted',
            properties: {
              'event trigger': 'Video Completed'
            }
          })
          break
      }
    }

    vm.onCompleteVideo = function onCompleteVideo (isCompleted) {
      if (isCompleted) {
        vm.trackEvent({
          action: 'complete',
          properties: {
            'event-trigger': ''
          }
        })
      }
    }

    vm.onUpdateTime = function onUpdateTime (newCurrentTime) {
      if (progressTracks.length > 0 && newCurrentTime >= progressTracks[0].jump) {
        vm.trackEvent({
          action: 'progress ' + progressTracks[0].percent + '%',
          properties: {
            'event-trigger': ''
          }
        })
        progressTracks.shift()
      }
    }

    vm.updateTrackInfo = function updateTrackInfo (newVal) {
      if (vm.analytics.category) info.category = vm.analytics.category
      if (vm.analytics.label) info.label = vm.analytics.label
    }

    vm.setValue = function setValue (eventType) {
      if (eventType) {
        if (eventType === 'percent') {
          if (vm.API.totalTime > 1000) {
            info.value = Math.floor((vm.API.currentTime / vm.API.totalTime) * 100)
          } else {
            info.value = 0
          }
        } else if (eventType === 'time') {
          info.value = Math.floor(vm.API.currentTime / 1000)
        }
      }
    }

    vm.addWatchers = function () {
      if (vm.analytics.category || vm.analytics.label) {
        info = {}

        vm.updateTrackInfo(vm.analytics)
      }

      $scope.$watch('vgTrackInfo', vm.updateTrackInfo, true)

      // Add ready track event
      if (vm.analytics.events.ready) {
        $scope.$watch(
          function () {
            return vm.API.isReady
          },
          function (newVal, oldVal) {
            vm.onPlayerReady(newVal)
          }
        )
      }

      // Add state track event
      if (vm.analytics.events.play || vm.analytics.events.pause || vm.analytics.events.stop) {
        $scope.$watch(
          function () {
            return vm.API.currentState
          },
          function (newVal, oldVal) {
            if (newVal !== oldVal) vm.onChangeState(newVal)
          }
        )
      }

      // Add complete track event
      if (vm.analytics.events.complete) {
        $scope.$watch(
          function () {
            return vm.API.isCompleted
          },
          function (newVal, oldVal) {
            vm.onCompleteVideo(newVal)
          }
        )
      }

      // Add progress track event
      if (vm.analytics.events.progress) {
        $scope.$watch(
          function () {
            return vm.API.currentTime
          },
          function (newVal, oldVal) {
            vm.onUpdateTime(newVal / 1000)
          }
        )

        var totalTimeWatch = $scope.$watch(
          function () {
            return vm.API.totalTime
          },
          function (newVal, oldVal) {
            totalMiliseconds = newVal / 1000

            if (totalMiliseconds > 0) {
              var totalTracks = vm.analytics.events.progress - 1
              var progressJump = Math.floor(totalMiliseconds * vm.analytics.events.progress / 100)

              for (var i = 0; i < totalTracks; i++) {
                progressTracks.push({
                  percent: (i + 1) * vm.analytics.events.progress,
                  jump: (i + 1) * progressJump
                })
              }

              totalTimeWatch()
            }
          }
        )
      }
    }

    vm.addWatchers()
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/component/video/video.js